<template>
  <div class="tabs">
    <!-- Tabs Menu -->
<!--    <nav-->
<!--      class="tabs-menu block-animation >> start__fade-down&#45;&#45;full-0 end__fade-up&#45;&#45;0-full"-->
<!--    >-->
<!--      <ul class="tab-group | space-b">-->
<!--        <li v-for="(item, index) in tabs" @click="updateTab(index)">-->
<!--          <button class="tab-btn">{{ item.name }}</button>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </nav>-->
    <!-- Tabs Content -->
    <div class="tabs-content">
      <slot name="tabsContent" :set-show-modal="setShowModal"></slot>
    </div>
    <article
      v-if="showModal"
      @click.self="showModal = false"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full"
    >
      <FocusTrap :active="showModal" :initial-focus="() => $refs.modal">
        <div tabindex="1" ref="modal" class="p-6 overflow-y-auto modal-inner">
          <header class="relative items-center mb-6 sm:flex">
            <div class="mb-4 mr-4 sm:mb-0 modal-image">
              <img
                :src="currentPerson.image"
                :alt="currentPerson.name"
                class="absolute top-0 left-0 object-cover w-full h-full"
              />
            </div>
            <div>
              <h3 class="mb-2 font-bold header-md">{{ currentPerson.name }}</h3>
              <p class="text-sm">{{ currentPerson.shortDescription }}</p>
              <div v-if="currentPerson.socials.length > 0" class="flex mt-4">
                <a
                  :href="social.url"
                  v-for="social in currentPerson.socials"
                  v-html="social.icon"
                  target="_blank"
                  class="mr-2"
                  :aria-label="social.channel"
                ></a>
              </div>
            </div>
            <button
              @click="showModal = false"
              aria-label="Close Modal"
              class="absolute top-0 right-0 self-start w-6 h-6"
            >
              <svg
                class="w-full h-full"
                viewBox="0 0 162 152"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="45"
                  height="191.387"
                  transform="matrix(1 0 -0.607653 0.794203 116.297 0)"
                  fill="white"
                />
                <rect
                  width="45"
                  height="191.387"
                  transform="matrix(-1 0 0.607653 0.794203 45 0)"
                  fill="white"
                />
              </svg>
            </button>
          </header>
          <div
            class="mt-8 text-sm modal-description sm:mt-0"
            v-html="currentPerson.description"
          ></div>
        </div>
      </FocusTrap>
    </article>
  </div>
</template>
<script>
import anime from "animejs";
import { FocusTrap } from "focus-trap-vue";
export default {
  components: { FocusTrap },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      currentPerson: null,
    };
  },
  mounted() {
    // Initialize with active
    const _this = this;
    _this.tabs.forEach((tab, i) => {
      if (typeof tab.active != "undefined" && tab.active != null) {
        const buttons = _this.$el.querySelectorAll("button"),
          activeButton = buttons[i],
          tabs = _this.$el.querySelectorAll(".tab"),
          activeTab = tabs[i],
          marker = "-active";

        // Update Menu
        buttons.forEach((button) => {
          // Remove Markers
          button.classList.remove(marker);
          // Mark Active
          activeButton.classList.add(marker);
        });
        // Update Content
        tabs.forEach((tab) => {
          // Remove Markers
          tab.classList.remove(marker);
          // Mark Active
          activeTab.classList.add(marker);
        });
      }
    });
  },
  methods: {
    setShowModal(value) {
      this.showModal = true;
      console.log(value);
      this.currentPerson = value;
    },
    updateTab(index) {
      const _this = this,
        tabs = _this.$el.querySelectorAll(".tab"),
        activeTab = tabs[index],
        buttons = _this.$el.querySelectorAll("button"),
        activeButton = event.target,
        marker = "-active";

      // Update Menu
      buttons.forEach((button) => {
        // Remove Markers
        button.classList.remove(marker);
        // Mark Active
        activeButton.classList.add(marker);
      });

      // Animate
      // Hide Inactiveo
      tabs.forEach((tab) => {
        anime({
          targets: tab,
          opacity: 0,
          duration: 400,
          easing: "easeInOutQuad",
          complete: function() {
            // Remove Markers
            tab.classList.remove(marker);
            // Mark Active
            activeTab.classList.add(marker);

            // Show Active
            anime({
              targets: activeTab,
              opacity: 1,
              duration: 400,
              easing: "easeInOutQuad",
            });
          },
        });
      });
    },
  },
};
</script>

<style lang="scss">
.tabs {
  .modal-description {
    p {
      margin-bottom: 1rem;
    }
  }
}
</style>
<style scoped lang="scss">
.modal-inner {
  background: rgb(0 0 0 / 0.8);
  color: var(--white);
  height: 100%;
  @media screen and (min-width: 700px) {
    width: 80%;
    max-width: 700px;
    max-height: 80%;
    height: auto;
  }
}

.modal-image {
  aspect-ratio: 1/1;
  position: relative;
  overflow: hidden;
  width: 40%;
  @media screen and (min-width: 700px) {
    width: 18%;
  }
}
</style>
